var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.forceLogin)?_c('NavbarMenu',{on:{"logout":_vm.logout}}):_vm._e(),_c('v-main',[(!_vm.forceLogin)?_c('bread-crumb'):_vm._e(),_c('router-view')],1),_vm._l((_vm.notifications),function(notification){return _c('Notification',{key:notification.id,attrs:{"notification":notification,"multi-line":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }